import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';
import React from 'react';

import { ShouldRender } from '../../shared/basic/ShouldRender';
import { CertificateCourse } from '../../../../assets';

const CourseCertificateSection: React.FC = () => {
  const screens = useBreakpoint();
  return (
    <div className='flex flex-col md:mt-0 mt-4 md:flex-row relative z-10 items-center gap-5 bg-black text-white p-4 xxxs:p-6 border border-[#282829] rounded-[12px]'>
      <ShouldRender check={screens.md}>
        <div className='relative flex w-[40%] md:w-[20%] lg:w-[60%] xl:w-52 h-20 xl:h-24  2xl:h-28'>
          <Image
            src={CertificateCourse}
            alt='Certificate Icon'
            layout='fill'
            objectFit='contain'
          />
        </div>
      </ShouldRender>
      <ShouldRender check={!screens.md}>
        <div className='absolute  w-full -top-[15%] z-30 left-[4%]'>
          <div className='relative flex w-[75px] h-[48px] '>
            <Image
              src={CertificateCourse}
              alt='Certificate Icon'
              layout='fill'
              objectFit='contain'
            />
          </div>
        </div>
      </ShouldRender>
      <div className='flex gap-y-1 xl:gap-y-2 flex-col'>
        <div className='block md:hidden h-3'></div>
        <h3 className='text-base xl:text-lg font-semibold'>
          Earn a Certificate on completion
        </h3>
        <p className='text-sm text-[#C7C6CF]'>
          Add this credential to your resume or CV. Share it on social media &
          in your performance review.
        </p>
      </div>
    </div>
  );
};

export default CourseCertificateSection;
